(function () {
  var SECTION_SELECTOR = '.oddit-section-cross-upsell';

  function revealInjected(root) {
    // Injected nodes aren't seen by the IntersectionObserver in
    // oddit-interactions.js, so mark them visible immediately (same as the
    // theme-editor reveal path) to avoid cards stuck at opacity 0.
    if (!root) return;
    root.querySelectorAll('.oddit-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function loadRecommendations(section) {
    if (section.getAttribute('data-products-source') !== 'recommendations') return;

    var grid = section.querySelector('[data-recommendations-grid]');
    if (!grid) return;

    var isFallback = section.getAttribute('data-recommendations-fallback') === 'true';
    var hasCards = !!grid.querySelector('.oddit-section-cross-upsell__card');

    // Real recommendations already server-rendered (served via the endpoint) —
    // nothing to fetch. A server-rendered *fallback* (BEB-100) still fetches
    // below so it can upgrade to personalised recommendations when available.
    if (hasCards && !isFallback) {
      revealInjected(grid);
      return;
    }

    var productId = section.getAttribute('data-product-id');
    var sectionId = section.getAttribute('data-section-id');
    if (!productId || !sectionId) return;
    var limit = section.getAttribute('data-recommendations-limit') || '3';
    var intent = section.getAttribute('data-recommendations-intent') || 'related';

    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root.replace(/\/$/, '') + '/recommendations/products'
      : '/recommendations/products';
    url += '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + encodeURIComponent(limit) +
      '&intent=' + encodeURIComponent(intent);

    fetch(url)
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = doc.querySelector('[data-recommendations-grid]');
        if (newGrid && newGrid.querySelector('.oddit-section-cross-upsell__card')) {
          grid.innerHTML = newGrid.innerHTML;
          revealInjected(grid);
        } else if (hasCards) {
          // No recommendations returned, but a server-rendered fallback is
          // already showing — keep it (BEB-100) rather than hiding the block.
          revealInjected(grid);
        } else {
          section.hidden = true;
        }
      })
      .catch(function () {
        // Network/endpoint failure: keep any server-rendered fallback; only
        // hide when there's genuinely nothing to show.
        if (hasCards) {
          revealInjected(grid);
        } else {
          section.hidden = true;
        }
      });
  }

  function handleAddToCart(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;

    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId) return;

    if (!window.OdditCartDrawer) {
      /* Cart drawer JS hasn't initialised yet. Fall back to a native cart add so
         the click is never a dead no-op. */
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      return;
    }

    var restWidth = button.getBoundingClientRect().width;
    button.style.minWidth = restWidth + 'px';

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    window.OdditCartDrawer.addToCart(variantId, 1)
      .then(function () {
        window.OdditCartDrawer.open();
      })
      .finally(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        button.style.minWidth = '';
      });
  }

  function initSection(section) {
    if (!section || section.dataset.odditBound === '1') return;
    section.dataset.odditBound = '1';

    section.addEventListener('click', function (e) {
      var button = e.target.closest('[data-add-to-cart]');
      if (!button || !section.contains(button)) return;
      handleAddToCart(button);
    });

    loadRecommendations(section);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
